import { useHttpClient } from "@/vf"

type LanguageIso = string
type TranslationKey = string

export type ServerSideLocaleMessages = Record<LanguageIso, Record<TranslationKey, string>>
export type ServerSideLocales = { messages: ServerSideLocaleMessages }

export async function useServerSideLocales(): Promise<ServerSideLocales> {
    const http = useHttpClient()
    const messages = (await http.get<ServerSideLocaleMessages>("locales.json")).data

    return {
        messages,
    }
}
